import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propChildren, propStr } from '../../../../helpers/custom-prop-types';
const ProffitSearchLandingPageSectionTitle = (props) => {
    const { className, mainText, subText } = props;
    return (_jsxs("div", Object.assign({ className: clsx('proffit_search_landing_page_section_title', className) }, { children: [_jsx("div", Object.assign({ className: 'title_sub' }, { children: _jsx("span", Object.assign({ className: 'sub_text button primary outline no-hover' }, { children: subText })) })), _jsx("h4", Object.assign({ className: 'title_main' }, { children: mainText }))] })));
};
ProffitSearchLandingPageSectionTitle.propTypes = {
    className: propStr(),
    mainText: propChildren().isRequired,
    subText: propStr().isRequired,
};
ProffitSearchLandingPageSectionTitle.defaultProps = {
    className: '',
};
export default ProffitSearchLandingPageSectionTitle;
